import { QueryClient } from '@tanstack/react-query';
import produce from 'immer';

import { findStudentIdByUuid } from '~teacher/components/ActivityResult/hooks/useActivityLiveEvent/utils';
import { ActivityResponse } from '~teacher/hook';

export const studentPresenceIntervalUpdater = ({
  uuidsJoined = [],
  uuidsLeft = [],
  uuidsTimedOut = [],
}: {
  uuidsJoined: string[];
  uuidsLeft: string[];
  uuidsTimedOut: string[];
}) =>
  produce((activityData: ActivityResponse) => {
    uuidsJoined.forEach((uuid) => {
      const studentId = findStudentIdByUuid(activityData, uuid);
      if (studentId) {
        activityData.students[studentId].isPresent = true;
      }
    });

    uuidsLeft.forEach((uuid) => {
      const studentId = findStudentIdByUuid(activityData, uuid);
      if (studentId) {
        activityData.students[studentId].isPresent = false;
      }
    });

    uuidsTimedOut.forEach((uuid) => {
      const studentId = findStudentIdByUuid(activityData, uuid);
      if (studentId) {
        activityData.students[studentId].isPresent = false;
      }
    });

    return activityData;
  });

export const studentPresenceIntervalCacheUpdater = ({
  queryClient,
  activityInstanceId,
  uuidsJoined = [],
  uuidsLeft = [],
  uuidsTimedOut = [],
}: {
  queryClient: QueryClient;
  activityInstanceId: number;
  uuidsJoined: string[];
  uuidsLeft: string[];
  uuidsTimedOut: string[];
}) => {
  queryClient.setQueryData(
    ['activity', activityInstanceId],
    studentPresenceIntervalUpdater({ uuidsJoined, uuidsLeft, uuidsTimedOut })
  );
};
